import React, {useState} from 'react';
import HomePage from './pages/HomePage';
import PathologicalPage from './pages/PathologicalPage'
import CohortPage from './pages/CohortPage'
import CaseAnalysisPage from './pages/CaseAnalysisPage';

export default function App(){
    const [page, setPage] = useState('home');
    const renderPage=()=>{
        switch(page){
            case 'home':
                return <HomePage setPage={setPage} />;
            case 'pathologic':
                return <PathologicalPage setPage={setPage}/>;
            case 'cohort':
                return <CohortPage setPage={setPage}/>;
            case 'multicase':
                return <CaseAnalysisPage setPage={setPage}/>;
            default:
                return <HomePage setPage={setPage} />; 
        }
    };
    return (
        <div>
            {renderPage()}
        </div>
    )
}
